export const getWWMuffinsPackage = newProduct => {
  let newWWMuffinsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    WholeWheatCert: newProduct.WholeWheatCert,
  }

  return newWWMuffinsPackage
}

export const updateWWMuffinsPackage = newProduct => {
  let newWWMuffinsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    WholeWheatCert: newProduct.WholeWheatCert,
  }

  return newWWMuffinsPackage
}
